import dateConverter from "./dateConverter";
import { getDatee } from "./getDatee";
import { getTime } from "./getTime";

const calcSeferSuresi = (seferSuresi, baslangicTarihi,baslangicSaati) => {
  let currentDate;
  if(baslangicTarihi?.includes("/")){
    baslangicTarihi = dateConverter(baslangicTarihi, "us-2")
  }

  if(baslangicTarihi && baslangicSaati){
    currentDate = new Date(`${baslangicTarihi}T${baslangicSaati}:00`)
  }
  else{
    currentDate = new Date()
  }
    const selectedDate = new Date(currentDate.getTime() + seferSuresi * 60 * 60 * 1000);

    
    return {
        date: getDatee(selectedDate),
        time:  getTime(selectedDate)
    }
  };

export {calcSeferSuresi}
